<template>
<div class="data-list">
  <div ref="body" class="datatable-wrapper">
    <table class="datatable" :key=tableUpdateKey>
      <thead ref="thead" class="datatable-head">
        <tr>
          <th class="number-col" ref="th-number">
            Nr.
          </th>
          <th class="assignees-col" ref="th-assignees">
            {{ $t('tasks.fields.assignees') }}
          </th>
          <th class="status-col" ref="th-status">
            {{ $t('tasks.fields.task_status') }}
          </th>
          <th class="real-end-date" ref="th-status">
            {{ $t('main.date') }}
          </th>
          <th class="empty" ref="">
            &nbsp;
          </th>
        </tr>
      </thead>

      <tbody
        class="datatable-body"
      >
        <tr
          :key="rev.task_status_id + rev.nr"
          class="rev-line datatable-row"
          v-for="rev in revisions"
        >
          <td class="number-col">
            {{ rev.nr }}
          </td>
          <multi-people-name-cell
            class="assignees-col"
            :peopleIds="rev.assign_history"
          />
          <task-status-name
            class="status-col status-name"
            :entry="rev.status"
          />
          <!-- </td> -->
          <td class="real-end-date">
            {{ rev.f_date }}
          </td>
          <td>
            <button-simple
              class="delete-revision-button"
              icon="delete"
              @click="deleteRevision(rev.id);"
              :key="rev.id + rev.f_date"
              v-if="rev.id !== ''"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TaskStatusName from '../cells/TaskStatusName'
import MultiPeopleNameCell from '../cells/MultiPeopleNameCell'
import ButtonSimple from '../widgets/ButtonSimple'
import { formatDate } from '../../lib/time'

export default {
  name: 'task-history-list',

  components: {
    TaskStatusName,
    MultiPeopleNameCell,
    ButtonSimple
  },

  data () {
    return {
      revisions: [],
      tableUpdateKey: 0
    }
  },

  props: {
    task: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters([
      'taskStatusMap',
      'taskMap'
    ])
  },

  methods: {
    ...mapActions([
      'deleteTaskHistory',
      'loadTask'
    ]),

    reset () {
      if (!this.task.history) {return}
      this.revisions = [ ...this.task.history ]
      for (let i = 0; i < this.revisions.length; i++) {
        this.revisions[i].nr = i + 1
        this.revisions[i].status = this.taskStatusMap.get(this.revisions[i].task_status_id)
        this.revisions[i].f_date = formatDate(this.revisions[i].created_at)
      }
      this.revisions.push({
        id: '',
        nr: this.revisions.length + 1,
        assign_history: this.task.assignees,
        task_status_id: this.task.task_status_id,
        status: this.taskStatusMap.get(this.task.task_status_id),
        f_date: '---'
      })
      this.revisions.reverse()
      this.tableUpdateKey = 0
    },

    adjustLastEntry () {
      if (this.revisions.length > 0) {
        this.revisions[0].task_status_id = this.task.task_status_id
        this.revisions[0].status = this.taskStatusMap.get(this.task.task_status_id)
        this.revisions[0].assign_history = this.task.assignees
        this.tableUpdateKey++
      }
    },

    deleteRevision (entryId) {
      this.deleteTaskHistory({
        taskId: this.task.id,
        entryId: entryId
      })
      this.loadTask({ taskId: this.task.id })
        .then(() => {
          this.reset()
        })
    }
  },

  watch: {
    'task.history' () {
      this.reset()
    },

    'task.task_status_id' () {
      this.adjustLastEntry()
    },

    'task.assignees' () {
      this.adjustLastEntry()
    }
  },

  mounted () {
    this.reset()
  }
}
</script>

<style scoped lang="scss">
.data-list {
  margin-top: 0.5em;
}

.number-col {
  max-width: 4em;
  // min-width: 4em;
  // width: 4em;
}

.assignees-col {
  width: auto
}

.status-col {
  max-width: 9em;
  // min-width: 9em;
  // width: 9em;
}

.real-end-date {
  max-width: 12em;
  // min-width: 12em;
  // width: 12em;
}

.empty {
  max-width: 4em;
  // min-width: 4em;
  width: 4em;
}
</style>
